<ng-container *ngrxLet="error$; let error">
    <ng-container [ngSwitch]="error?.type">
        <div *ngSwitchCase="FlightZoneErrorType.CannotGetApplication" class="error">
            {{ "dssAdminLibFlightZoneManagement.cannotGetDataErrorMessage" | transloco }}
        </div>
        <ng-container *ngSwitchDefault>
            <ng-container *ngTemplateOutlet="noErrorTemplate"></ng-container>
        </ng-container>
    </ng-container>
</ng-container>

<ng-template #noErrorTemplate>
    <div class="application-preview" *ngIf="flightZoneRestrictionData$ | ngrxPush; let flightZoneRestrictionData">
        <div class="card-box">
            <div class="overflow-container">
                <dss-shared-lib-restriction-preview-header
                    [headerTitle]="'dssAdminLibFlightZoneManagement.applicationPreview.title' | transloco"
                    [isProcessing]="isProcessing$ | ngrxPush"
                    (pdfDownload)="downloadPdf(flightZoneRestrictionData)"
                    (confirmationOfApplicationSubmissionPdfDownload)="
                        downloadConfirmationOfApplicationSubmissionPdf(flightZoneRestrictionData)
                    "
                >
                </dss-shared-lib-restriction-preview-header>
                <dss-shared-lib-application-summary
                    [basicDataForm]="flightZoneRestrictionData.basicData"
                    [restrictionAreaGeometry]="flightZoneRestrictionData.restrictionAreaGeometry"
                    [restrictionExclusions]="flightZoneRestrictionData.restrictionExclusions"
                    [analysisStatus]="flightZoneRestrictionData.analysisStatus"
                    [capabilities]="capabilities$ | ngrxPush"
                >
                </dss-shared-lib-application-summary>
                <dss-shared-lib-application-note [note]="flightZoneRestrictionData.note" isReadOnly></dss-shared-lib-application-note>
            </div>
            <div class="actions">
                <button
                    type="button"
                    *ngIf="flightZoneRestrictionData.analysisStatus.notamNumber"
                    class="button-primary full-width-button"
                    (click)="openNotamPreview(flightZoneRestrictionData.lastApplicationId)"
                >
                    {{ "dssAdminLibFlightZoneManagement.applicationPreview.openNotamButtonLabel" | transloco }}
                </button>
                <button class="button-secondary" (click)="zoomToGeometry()" type="button">
                    <dtm-ui-icon name="focus-2"></dtm-ui-icon>
                    {{ "dssAdminLibFlightZoneManagement.applicationPreview.zoomToZoneButtonLabel" | transloco }}
                </button>
            </div>
        </div>
        <dss-shared-lib-map-container shouldShowActiveRestrictionsLayer></dss-shared-lib-map-container>
    </div>
</ng-template>
